import SocialShare from './SocialShare';
import ScrollProgress from './ScrollProgress';
import BackToTop from './BackToTop';

const ShareThisPost = (props) => {
    return (
        <div className="common-wrapper mb-4 position-relative">
            <h3 className="mb-4 fw-500 text-uppercase text-4">Share this post</h3>
            <SocialShare title={props.title} link={window.location.href} />
            <ScrollProgress targetSelector=".post-content" />
            <BackToTop offset={200} title={true} />
        </div>
    );        
}

export default ShareThisPost;